import {useQuery} from 'react-query';
import {getAllListLoanRequest} from './getAllListLoanRequest';

const useGetAllListLoanRequest = (
  payload?: IListLoanRequestPayload,
  caching?: 'no-cache',
) => {
  const {data, isLoading, refetch, isSuccess} = useQuery(
    ['get-list-loan-request', payload], // Dynamic queryKey based on payload
    () => getAllListLoanRequest(payload), // Correct queryFn
    {
      cacheTime: caching === 'no-cache' ? 0 : 300000, // Cache time (0 for no cache)
      staleTime: caching === 'no-cache' ? 0 : 60000, // Stale time (0 for no stale)
      // refetchOnWindowFocus: caching === 'no-cache', // Always refetch when window refocuses
      refetchOnReconnect: caching === 'no-cache', // Always refetch on reconnect
      refetchInterval: caching === 'no-cache' ? 0 : undefined, // Prevent periodic refetch in no-cache mode
    },
  );

  return {data, isLoading, refetch, isSuccess};
};

export default useGetAllListLoanRequest;
